/**
 * Categories API – mirrors src/services/categories.ts and routes/categories.ts
 * in vin-pulse-os-api.
 *
 * GET /api/v1/categories returns `{ data: BackendCategory[] }`. Mapper here
 * converts to the frontend's `Category` type so existing components don't
 * need changes.
 */

import { apiClient } from './apiClient';
import type { Category as FrontendCategory } from '../types';

export interface BackendCategory {
  id: number;
  name: string;
  description: string | null;
  parent_id: number | null;
  is_active: boolean;
  sku_count: number;
  total_stock: number;
  total_revenue: number;
  avg_margin: number;
  created_at: string;
  updated_at: string;
}

export async function listBackendCategories(): Promise<BackendCategory[]> {
  // The route wraps as `{ data: [...] }`; apiClient.get unwraps the outer
  // `data`, leaving us with the inner array directly.
  const raw = await apiClient.get<BackendCategory[] | { data: BackendCategory[] }>('/categories');
  if (Array.isArray(raw)) return raw;
  return raw?.data ?? [];
}

export function categoryToFrontend(c: BackendCategory): FrontendCategory {
  return {
    id: c.id,
    name: c.name,
    slug: c.name.toLowerCase().replace(/[^a-z0-9]+/g, '-'),
    image: '',
    description: c.description ?? '',
    productCount: c.sku_count,
  };
}
